import { z } from 'zod'
import { type UserPermission } from '../../models/UserPermision'
import { mapUserPermissionToDomain, mapUserPermissionToSubDomain } from '../../composables/useUserPermission'

export const UserPermissionDTO = z.object({
  name: z.string(),
  description: z.string(),
  parent: z.string().nullish()
})

export type UserPermissionDTO = z.infer<typeof UserPermissionDTO>

export function mapUserPermissionToDTO (model: UserPermission): string {
  return model.name
}

export function mapDTOToUserPermission (dto: UserPermissionDTO): UserPermission {
  const domain = mapUserPermissionToDomain(dto.name)
  return {
    name: dto.name,
    description: dto.description,
    domain,
    subDomain: mapUserPermissionToSubDomain(dto.name),
    parent: dto.parent ?? null
  }
}

export function createUserPermissionFromName (name: string, description: string): UserPermission {
  return mapDTOToUserPermission({ name, description })
}
